<template>
  <v-container>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Hoy
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar" class="ml-2">
              {{ $refs.calendar.title.toUpperCase() }}
            </v-toolbar-title>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :type="type"
            @click:event="showEvent"
            @click:date="openDialogEvent"
            @click:more="openDialogEventMore"
            locale="es-VE"
          ></v-calendar>

          <!-- menu rapido de evento -->
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-toolbar-title>
                  {{ selectedEvent.name }}
                  ({{ selectedEvent.is_public ? "PUBLICO" : "PRIVADO" }})
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text> </v-card-text>
              <v-card-text>
                {{ selectedEvent.description }}
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- dialog form event y list event de date -->
    <v-dialog v-model="dialogEvent" width="600">
      <v-card>
        <v-card-title> Eventos </v-card-title>
        <v-card-text>
          <v-tabs color="primary">
            <v-tab>Nuevo evento</v-tab>
            <v-tab>Lista de eventos</v-tab>

            <v-tab-item>
              <event-form
                schema="new"
                :start="start"
                @addEvent="addEvent"
                @closeDialogEvent="closeDialogEvent"
              />
            </v-tab-item>

            <v-tab-item>
              <event-list-form
                :start="start"
                :eventList="eventList"
                @editEventCalendar="editEventCalendar"
                @deleteEventCalendar="deleteEventCalendar"
              />
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialog list de event more -->
    <v-dialog v-model="dialogEventMore" width="600">
      <event-list-form
        :start="start"
        :eventList="eventList"
        @editEventCalendar="editEventCalendar"
        @deleteEventCalendar="deleteEventCalendar"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import eventForm from "../Forms/eventForm.vue";
import EventListForm from "../Forms/eventListForm.vue";

export default {
  components: { eventForm, EventListForm },

  data: () => ({
    dialogEventMore: false,
    dialogEventShow: false,
    event: {},
    eventList: [],
    loadingEvents: true,
    start: null,
    tab: null,
    dialogEvent: false,
    focus: "",
    type: "month",
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
  }),

  mounted() {
    this.loadEvents();
    this.$refs.calendar.checkChange();
  },

  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },

    setToday() {
      this.focus = "";
    },

    prev() {
      this.$refs.calendar.prev();
    },

    next() {
      this.$refs.calendar.next();
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    openDialogEvent(event) {
      this.start = event.date;
      this.$store
        .dispatch("findEventByDateAction", { date: event.date })
        .then((res) => {
          this.eventList = res;
        });

      this.dialogEvent = true;
    },

    closeDialogEvent() {
      this.dialogEvent = false;
    },

    loadEvents() {
      this.$store.dispatch("findEventsAction").then((res) => {
        this.events = res;
      });
    },

    openDialogEventMore(event) {
      this.start = event.date;
      this.$store
        .dispatch("findEventByDateAction", { date: event.date })
        .then((res) => {
          this.eventList = res;
        });

      this.dialogEventMore = true;
    },

    addEvent(event) {
      this.events.push(event);
      this.dialogEvent = false;
    },

    editEventCalendar(event) {
      let index = this.events.findIndex((e) => e.id == event.id);
      this.events.splice(index, 1, event);
    },

    deleteEventCalendar(event) {
      let index = this.events.findIndex((e) => e.id == event.id);
      this.events.splice(index, 1);
    },
  },
};
</script>
<style></style>
